var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNosearchresults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1465 6.03334C8.45451 17.096 -5.02964 48.5209 6.03306 76.213C17.0958 103.905 48.5169 117.38 76.209 106.317C86.5912 102.17 94.9728 95.1707 100.809 86.5718C100.906 86.4363 100.993 86.3045 101.081 86.1727C101.701 85.2464 102.283 84.3033 102.84 83.3268C103.634 81.9975 104.355 80.6219 105.007 79.209C105.028 79.1793 105.045 79.1403 105.061 79.1013C105.225 78.756 105.379 78.4144 105.526 78.0542C105.942 77.1556 106.316 76.231 106.664 75.2953C107.779 72.3729 108.638 69.3483 109.228 66.2698C111.103 56.4863 110.296 46.0833 106.326 36.1468C95.2635 8.45479 63.8386 -5.02936 36.1465 6.03334ZM72.5942 96.2713C50.5204 105.09 25.4767 94.3435 16.6621 72.279C7.84759 50.2145 18.5899 25.1615 40.6637 16.3433C62.7375 7.52502 87.7719 18.2748 96.5902 40.3485C105.408 62.4223 94.6587 87.4568 72.5942 96.2713Z",
    stroke: "#255097",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosearchresults);
export default __webpack_public_path__ + "static/media/nosearchresults.979405fd9b790791db16b393897c9745.svg";
export { ForwardRef as ReactComponent };